import styles from './Order.module.scss';
import Header from '../../components/Header/Header';
import selectOpen from '../../assets/selectOpen.png';
import leftArrow from '../../assets/leftArrow02.png';
import bottomArrow from '../../assets/bottomArrow04.png';
import rightArrow from '../../assets/rightArrow06.png';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { SetStateAction, useEffect, useRef, useState } from 'react';
import DaumPostcode from 'react-daum-postcode';
import { isMobile, isDesktop } from 'react-device-detect';
import closeBtn from '../../assets/closeBtn03.png';
import CouponModal from '../../components/CouponModal/CouponModal';
import axiosClient from '../../libs/axiosClient';
import { IBasketDataType, IBasketProductType } from '../Basket/Basket';
import jwt_decode from 'jwt-decode';
import { ITokenInfoType, logout } from '../../auth/auth';
import LoginHandler from '../../components/LoginHandler/LoginHandler';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import countryData from '../../assets/data/countryData.json';
import usaState from '../../assets/data/usaState.json';
import canadaState from '../../assets/data/canadaState.json';
import australiaState from '../../assets/data/australiaState.json';
import AddressSelectModal from '../../components/AddressSelectModal/AddressSelectModal';
import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js';
import OrderComplete from '../OrderComplete/OrderComplete';
import ReactPixel from 'react-facebook-pixel';
import TiktokPixel from 'tiktok-pixel';

const tiktokID = 'CPBV32BC77U97SP6COMG';

declare var daum: any;
declare var fbq: (...args: any[]) => void;

// const phoneRegex = /^[0-9]*$/;
const phoneRegex = /^[\d+-]*$/;
const payappTelRegex = /^01[0-9]*$/;
const nameRegex = /^[ㄱ-ㅎ가-힣a-zA-Z0-9\s]+$/;
const addressRegex = /^[a-zA-Z0-9\s\.\,#-]+$/;
const zipcodeRegex = /^[0-9\s-]+$/;

const emailRegex =
  /^([\w\.\_\-])*[a-zA-Z0-9]+([\w\.\_\-])*([a-zA-Z0-9])+([\w\.\_\-])+@([a-zA-Z0-9]+\.)+[a-zA-Z0-9]{2,8}$/;
const telRegex = /^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})-?[0-9]{3,4}-?[0-9]{4}$/;
const registrationNumberRegex =
  /^(?:[0-9]{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[1,2][0-9]|3[0,1]))-[1-8][0-9]{6}$/;
export interface ICouponType {
  company_id: null | string;
  coupon_name: string;
  coupon_target: string;
  created_at: string;
  discount_maximum_price: number;
  discount_type: string;
  discount_value: number;
  expire_date: string;
  id: string;
  min_order_price: number;
  product_id: string;
  status: string;
  type: string;
  used_at: string;
}
function Order() {
  const tagNum = [12, 13, 16, 17];
  const navigate = useNavigate();
  const params = useParams();
  const { cartId } = useParams();
  const { isDirect } = useParams();
  const [ip, setIp] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [needPrescription, setNeedPrescription] = useState(false);
  const location = useLocation();
  // const [lineId, setLineId] = useState('');
  // 주문자 정보 상태
  const [ordererName, setOrdererName] = useState('');
  const [ordererEmail, setOrdererEmail] = useState('');
  const [ordererTel, setOrdererTel] = useState('');
  // 주문자 정보 상태

  // 문진표 정보 상태
  const [ordererSame, setOrdererSame] = useState(true);
  const [patientName, setPatientName] = useState('');
  const [patientTel, setPatientTel] = useState('');
  const [patientBirth, setPatientBirth] = useState('');
  const [patientAge, setPatientAge] = useState('');
  const [patientHeight, setPatientHeight] = useState('');
  const [patientWeight, setPatientWeight] = useState('');
  const [reason, setReason] = useState('');
  const [pregnancy, setPregnancy] = useState<boolean>();
  const [dailyCoffee, setDailyCoffee] = useState(0); //하루 커피 섭취량
  const [caffeineSensitivity, setCaffeineSensitivity] = useState(0); //카페인 예민도
  const [dietPillsExperience, setDietPillsExperience] = useState([
    false,
    false,
    false,
    false,
  ]); //다이어트약 복용경험
  const [dietPillsLevel, setDietPillsLevel] = useState(0); //약 강도
  const [sideEffects, setSideEffects] = useState('');
  // 문진표 정보 상태

  // 배송지 정보 상태
  const [openPostcode, setOpenPostcode] = useState<boolean>(false);
  const [deliveryType, setDeliveryType] = useState(-1);
  const [deliveryName, setDeliveryName] = useState('');
  const [deliveryTel, setDeliveryTel] = useState('');
  const [zipCode, setZipCode] = useState('');
  //미국 버전 주소 관련 상태
  const [deliveryCountry, setDeliveryCountry] = useState('');
  const [deliveryState, setDeliveryState] = useState('');
  const [deliveryAddress1, setDeliveryAddress1] = useState('');
  const [deliveryAddress2, setDeliveryAddress2] = useState('');
  const [stateArray, setStateArray] = useState<string[]>([]);

  useEffect(() => {
    if (!deliveryCountry) setStateArray([]);
    if (deliveryCountry === 'USA') setStateArray(usaState);
    if (deliveryCountry === 'Canada') setStateArray(canadaState);
    if (deliveryCountry === 'Australia') setStateArray(australiaState);
  }, [deliveryCountry]);

  // 결제 버튼 상태
  const [paypalBtn, setPaypalBtn] = useState(true);

  // 주별 배송비
  const [deliveryPrice, setDeliveryPrice] = useState(0);

  // useEffect(() => {
  //   if (!deliveryState || !orderData) return;

  //   let devPrice = 0;
  //   regions.some((region) => {
  //     if (region.list.includes(deliveryState)) {
  //       if (totalCnt < 4) {
  //         devPrice = region.prices[0];
  //       } else if (totalCnt == 4) {
  //         devPrice = region.prices[1];
  //       } else {
  //         if (region.prices[totalCnt - 3])
  //           devPrice = region.prices[totalCnt - 3];
  //         else devPrice = region.prices[region.prices.length - 1];
  //       }
  //       return true;
  //     }
  //   });
  //   setDeliveryPrice(devPrice);
  // }, [deliveryState]);

  //미국 버전 주소 관련 상태
  const [deliveryMemo, setDeliveryMemo] = useState('');

  //SNS ID
  const [snsIdMethod, setSnsIdMethod] = useState('kakaotalk');
  const [deliverySnsId, setDeliverySnsId] = useState('');
  useEffect(() => {
    if (openPostcode) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = 'auto';
  }, [openPostcode]);

  // 할인혜택 정보 상태
  const [discountInfoOpen, setDiscountInfoOpen] = useState(false);
  const [userPoint, setUserPoint] = useState(0);
  const [point, setPoint] = useState<number>(0);
  const [usePoint, setUsePoint] = useState(0);
  function pointApply() {
    if (userPoint < 1) {
      alert('Points can be used starting from $1 or more.');
      return;
    }
    if (point % 1 !== 0) {
      alert('Points can be used in increments of $1.');
      return;
    }
    let confirm = window.confirm(t('other.46')!);
    if (confirm) setUsePoint(point);
  }

  const [promotion, setPromotion] = useState('');
  const [promotionPrice, setPromotionPrice] = useState(0);
  const [promotionPercent, setPromotionPercent] = useState(0);
  function checkPromotion() {
    axiosClient
      .get(`/data/promotion/check-code?promotion_code=${promotion}`)
      .then((res) => {
        if (res.data.result == 'Fail') {
          alert(t('other.28'));
          return;
        }
        let usePromotion = window.confirm(t('other.47')!);
        if (usePromotion) {
          if (res.data.data.discount_type == 'price') {
            setPromotionPrice(res.data.data.discount_value);
            setPromotionPercent(0);
          } else if (res.data.data.discount_type == 'per') {
            setPromotionPercent(res.data.data.discount_value);
            setPromotionPrice(0);
          }
        } else {
          setPromotionPrice(0);
          setPromotionPercent(0);
        }
      });
  }

  const [sellerCoupon, setSellerCoupon] = useState('');
  const [sellerCouponPrice, setSellerCouponPrice] = useState(0);
  const [sellerCouponPercent, setSellerCouponPercent] = useState(0);
  function checkSellerCoupon() {
    let queryString = `seller_coupon_str=${sellerCoupon.trim()}&`;
    orderData?.carts.map((company) => {
      company.cart.map((product) => {
        product.items.map((option) => {
          queryString += `cart_ids=${String(option.id)}&`;
        });
      });
    });
    axiosClient
      .get(`/data/coupon/use-seller-coupon?${queryString}`)
      .then((res) => {
        if (res.data.result == 'Fail') {
          alert(t('other.61'));
          return;
        }
        let useSellerCoupon = window.confirm(t('other.62')!);
        if (useSellerCoupon) {
          if (res.data.discount_type == 'price') {
            setSellerCouponPrice(res.data.discount_value);
            setSellerCouponPercent(0);
          } else if (res.data.discount_type == 'per') {
            setSellerCouponPercent(res.data.discount_value);
            setSellerCouponPrice(0);
          }
        } else {
          setSellerCouponPrice(0);
          setSellerCouponPercent(0);
        }
      })
      .catch((err) => alert(err.response.data.detail));
  }
  // 할인혜택 정보 상태

  // 결제수단 상태
  const [payMethod, setPayMethod] = useState(1);
  const [selectedBankId, setSelectedBankId] = useState<number>();
  const [depositorName, setDepositorName] = useState('');
  const [eximbayAgencyCode, setEximbayAgencyCode] = useState('P000');

  useEffect(() => {
    (async () => {
      await getCouponData();
      await getPointData();
    })();
  }, []);
  async function getCouponData() {
    await axiosClient
      .get('/data/coupon')
      .then((res) => setCouponList(res.data.data.coupons));
  }
  async function getPointData() {
    await axiosClient.get('/data/point').then((res) => {
      setUserPoint(res.data.data.total_point);
    });
  }
  // 결제수단 상태

  // 약관동의 관련 상태
  const [payAgree, setPayAgree] = useState(false);
  const [privacyAgree, setPrivacyAgree] = useState(false);
  const [diagnosisAgree, setDiagnosisAgree] = useState(false);
  const [payAgreeOpen, setPayAgreeOpen] = useState(false);
  const [privacyAgreeOpen, setPrivacyAgreeOpen] = useState(false);
  const [diagnosisAgreeOpen, setDiagnosisAgreeOpen] = useState(false);
  const [agreementModalOpen, setAgreementModalOpen] = useState(false);
  const [agreementModalType, setAgreementModalType] = useState(-1);
  useEffect(() => {
    if (agreementModalOpen) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = 'auto';
  }, [agreementModalOpen]);
  // 약관동의 관련 상태
  // 쿠폰 관련 상태
  const [couponModalOpen, setCouponModalOpen] = useState(false);
  const [couponList, setCouponList] = useState<ICouponType[]>([]);
  const [useCoupon, setUseCoupon] = useState<ICouponType>();
  useEffect(() => {
    if (couponModalOpen) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = 'auto';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [couponModalOpen]);
  // 쿠폰 관련 상태

  //포인트, 쿠폰, 프로모션
  const [totalDiscountPrice, setTotalDiscountPrice] = useState(0);
  useEffect(() => {
    //%할인 쿠폰이나 %할인 프로모션 사용시 최종 금액에서 쿠폰 할인 적용 => 쿠폰 할인 적용된 금액에서 다시 프로모션 쿠폰 금액 적용
    if (!orderData) return;
    let sellerCoupon =
      sellerCouponPrice !== 0
        ? sellerCouponPrice
        : sellerCouponPercent !== 0
        ? Math.floor(
            orderData.total_discount_price_sum * (sellerCouponPercent / 100),
          )
        : 0;
    let couponPrice = useCoupon
      ? useCoupon.discount_type == 'price' //쿠폰 타입이 price이면
        ? useCoupon.discount_value // 단순 쿠폰 할인 금액을 추가하고,
        : useCoupon.discount_type == 'per' // 쿠폰 타입이 per이면
        ? Math.floor(
            (orderData.total_discount_price_sum - sellerCoupon) *
              (useCoupon.discount_value / 100), //쿠폰 할인 %계산해서 추가
          )
        : 0
      : 0;
    let promotion =
      promotionPrice !== 0
        ? promotionPrice
        : promotionPercent !== 0
        ? Math.floor(
            (orderData.total_discount_price_sum - sellerCoupon - couponPrice) *
              (promotionPercent / 100),
          )
        : 0;
    setTotalDiscountPrice(sellerCoupon + usePoint + promotion + couponPrice);
  }, [
    sellerCouponPrice,
    sellerCouponPercent,
    usePoint,
    promotionPrice,
    promotionPercent,
    useCoupon,
  ]);
  //포인트, 쿠폰, 프로모션
  useEffect(() => {
    if (ordererSame) {
      setPatientName(ordererName);
      setPatientTel(ordererTel);
    } else {
      setPatientName('');
      setPatientTel('');
    }
  }, [ordererSame]);
  useEffect(() => {
    if (deliveryType == 0) {
      setDeliveryName(ordererName);
      setDeliveryTel(ordererTel);
    }
  }, [deliveryType]);

  //스크롤 위치에 따른 구매하기 버튼 fixed처리
  const buyBtnRef = useRef<HTMLDivElement>(null);
  const [isFixed, setIsFixed] = useState(true);
  useEffect(() => {
    if (!buyBtnRef.current) return;
    const io = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting || isDesktop) {
        setIsFixed(false);
      } else {
        setIsFixed(true);
      }
    });
    io.observe(buyBtnRef.current);
    return () => io.disconnect();
  }, [isFixed]);
  //스크롤 위치에 따른 구매하기 버튼 fixed처리

  const [validation, setValidation] = useState({
    ordererName: false,
    ordererEmail: false,
    ordererTel: false,
    patientName: false,
    patientTel: false,
    patientHeight: false,
    patientWeight: false,
    reason: false,
    pregnancy: false,
    dailyCoffee: false,
    caffeineSensitivity: false,
    dietPillsExperience: false,
    dietPillsLevel: false,
    sideEffects: false,
    disease: false,
    medicine: false,
    deliveryName: false,
    deliveryTel: false,
    deliverySnsId: false,
    zipCode: false,
    deliveryCountry: false,
    deliveryState: false,
    deliveryAddress1: false,
    deliveryAddress2: false,
    payAgree: false,
    privacyAgree: false,
    diagnosisAgree: false,
    selectedBankId: false, //payMethod가 무통장입금이면 은행 선택여부 체크
    depositorName: false, //무통장입금시 입금자명 기입 여부
  });
  function checkValidate() {
    let validate: any = { ...validation };
    Object.entries(validate).map((val) => {
      validate[val[0]] = false;
    });
    //주문자 정보 검증
    if (!nameRegex.test(ordererName)) validate.ordererName = true;
    if (!emailRegex.test(ordererEmail)) validate.ordererEmail = true;
    // if (ordererTel.length < 10) validate.ordererTel = true;
    // if (!phoneRegex.test(ordererTel) || ordererTel.length < 10)
    if (!ordererTel.length) validate.ordererTel = true;
    if (payMethod === 0) {
      if (!payappTelRegex.test(ordererTel) || ordererTel.length !== 11)
        validate.ordererTel = true;
    }
    //주문자 정보 검증
    //문진표 정보 검증
    if (needPrescription) {
      if (patientName.length == 0) validate.patientName = true;
      if (patientTel.length < 10) validate.patientTel = true;
      if (!patientHeight.length) validate.patientHeight = true;
      if (!patientWeight.length) validate.patientWeight = true;
      if (!reason.length) validate.reason = true;
      if (pregnancy == undefined) validate.pregnancy = true;
      if (dailyCoffee == 0) validate.dailyCoffee = true;
      if (caffeineSensitivity == 0) validate.caffeineSensitivity = true;
      if (!dietPillsExperience.includes(true))
        validate.dietPillsExperience = true;
      if (!dietPillsExperience[0]) {
        if (dietPillsLevel == 0) validate.dietPillsLevel = true;
        if (sideEffects.length == 0) validate.sideEffects = true;
      }
      //질병 여부 검증
      if (disease == undefined) validate.disease = true;
      //질병 여부 검증
      //복용중인 약 검증
      if (medicine == undefined) validate.medicine = true;
      //복용중인 약 검증
    }
    //문진표 정보 검증
    //배송지 정보 검증
    if (!nameRegex.test(deliveryName)) validate.deliveryName = true;
    if (!deliveryTel.length) validate.deliveryTel = true;
    if (!zipcodeRegex.test(zipCode) || !zipCode.length) validate.zipCode = true;
    if (!deliveryCountry.length) validate.deliveryCountry = true;
    if (!deliveryState.length) validate.deliveryState = true;
    if (!addressRegex.test(deliveryAddress1) || !deliveryAddress1.length)
      validate.deliveryAddress1 = true;
    if (!addressRegex.test(deliveryAddress2) || !deliveryAddress2.length)
      validate.deliveryAddress2 = true;
    // if (!deliveryAddress3.length) validate.deliveryAddress3 = true;
    // if (!deliveryAddressDetail.length) validate.deliveryAddressDetail = true;
    //배송지 정보 검증

    // sns id 검증
    if (!deliverySnsId.length) validate.deliverySnsId = true;

    //약관 동의 검증
    // if (payMethod !== 2) {
    //   if (!payAgree) validate.payAgree = true;
    //   if (!privacyAgree) validate.privacyAgree = true;
    //   if (!diagnosisAgree) validate.diagnosisAgree = true;
    // }
    //약관 동의 검증

    setValidation({ ...validate });
    if (Object.values(validate).includes(true)) {
      // if (!payAgree || !privacyAgree || !diagnosisAgree)
      //   alert(t('other.23'));
      // else alert(t('other.29'));
      // alert(t('other.29'));
      if (validate.ordererTel) alert(t('other.64'));
      else alert(t('other.29'));
      return false;
    } else return true;
  }

  function getOrderProductName() {
    if (!orderData) {
      return;
    }
    let productName = orderData.carts[0].cart[0].product.title;
    let count = 0;
    orderData.carts.map((company) =>
      company.cart.map((product) => {
        count++;
      }),
    );
    if (count !== 1) {
      productName += `${count - 1} others`;
    }
    return productName;
  }
  /*
   *  연동방식별 파라미터 세팅 ('결제하기' 버튼 클릭시 호출)
   */
  // 결제창 넘어가기 전에 입력 정보 저장(뒤로가기, 결제 취소 대비)
  function saveInfo() {
    const infomation: any = {};
    // infomation.lineId = lineId;
    infomation.ordererName = ordererName;
    infomation.ordererEmail = ordererEmail;
    infomation.ordererTel = ordererTel;
    infomation.patientName = patientName;
    infomation.patientTel = patientTel;
    infomation.patientBirth = patientBirth;
    infomation.patientAge = patientAge;
    infomation.patientHeight = patientHeight;
    infomation.patientWeight = patientWeight;
    infomation.caffeineSensitivity = caffeineSensitivity;
    infomation.dailyCoffee = dailyCoffee;
    infomation.dietPillsExperience = dietPillsExperience;
    infomation.dietPillsLevel = dietPillsLevel;
    infomation.sideEffects = sideEffects;
    infomation.reason = reason;
    infomation.pregnancy = pregnancy;
    infomation.disease = disease;
    infomation.diseaseDetail = diseaseDetail;
    infomation.medicine = medicine;
    infomation.medicineDetail = medicineDetail;
    infomation.deliveryName = deliveryName;
    infomation.deliveryTel = deliveryTel;
    infomation.deliverySnsId = deliverySnsId;
    infomation.zipCode = zipCode;
    infomation.deliveryCountry = deliveryCountry;
    infomation.deliveryState = deliveryState;
    infomation.deliveryAddress1 = deliveryAddress1;
    infomation.deliveryAddress2 = deliveryAddress2;
    infomation.deliveryPriceSum = deliveryPriceSum;
    infomation.deliveryMemo = deliveryMemo;
    infomation.payMethod = payMethod;
    infomation.eximbayAgencyCode = eximbayAgencyCode;
    sessionStorage.setItem('temporaryOrderInfo', JSON.stringify(infomation));
    sessionStorage.setItem('lastOrderPageUrl', location.pathname);
  }
  // 결제창 넘어가기 전에 입력 정보 저장(뒤로가기, 결제 취소 대비)

  useEffect(() => {
    axios.get('https://geolocation-db.com/json/').then((res) => {
      setIp(res.data.IPv4);
    });
  }, []);
  
  const extractIsDirect = () => {
    const path = location.pathname.split('/');
    return path[2] || '';
  };

  let formData = new FormData();
  
  useEffect(() => {
    // 이미 로드되어 있다면 중복 로드 방지
    if (document.getElementById('portoneScript')) return;

    const script = document.createElement('script');
    script.src = 'https://static.portone.cloud/portone.js';
    script.id = 'portoneScript';
    document.body.appendChild(script);

    // cleanup - 컴포넌트 언마운트 시 스크립트를 제거하려면
    return () => {
      if (document.getElementById('portoneScript')) {
        document.body.removeChild(script);
      }
    };
  }, []);
  
  const handleClick = async () => {
    if (!orderData) return;
    
    // 포트원
    if (payMethod === 1) {
      try {
        const formData = new FormData();
        orderData?.carts.map((company) => {
          company.cart.map((product) => {
            product.items.map((option) => {
              formData.append('cart_ids', String(option.id));
            });
          });
        });
        formData.append('is_direct', extractIsDirect());
        formData.append('order_name', ordererName);
        formData.append('order_email', ordererEmail);
        formData.append('order_phone', ordererTel);
        formData.append('address_name', deliveryName);
        formData.append('address_phone', deliveryTel);
        formData.append('messanger', snsIdMethod === 'kakaotalk' ? `${snsIdMethod}__${deliverySnsId}` : '');
        formData.append('address_zipcode', zipCode);
        formData.append('country_name', deliveryCountry);
        formData.append('address_state', deliveryState);
        formData.append('address_address1', deliveryAddress1);
        formData.append('address_address2', deliveryAddress2);
        formData.append('request_memo', deliveryMemo);
        formData.append('amount', String(orderData?.total_discount_price_sum));
        formData.append('delivery', orderData?.total_delivery_sum === 0 ? String(deliveryPriceSum) : String(orderData?.total_delivery_sum));
        formData.append('use_point', String(usePoint));
        formData.append('total_amount_sum', String(orderData!.total_discount_price_sum + deliveryPriceSum + orderData!.total_delivery_sum - totalDiscountPrice));
        formData.append('pay_method', 'card');
        formData.append('pg', 'portone');
        
        if (needPrescription) {
          formData.append('user_name', patientName);
          formData.append('phone', patientTel);
          formData.append('social_number', patientBirth);
          formData.append('age', patientAge);
          formData.append('height', patientHeight);
          formData.append('weight', patientWeight);
          formData.append('is_pregnant', pregnancy ? 'Y' : 'N');
          formData.append('question', reason);
          formData.append('is_disease', disease ? 'Y' : 'N');
          formData.append('disease', diseaseDetail);
          formData.append('is_taking_medicines', medicine ? 'Y' : 'N');
          formData.append('taking_medicines', medicineDetail);
          formData.append('daily_coffee_intake', String(dailyCoffee));
          formData.append('caffeine_sensitivity', String(caffeineSensitivity));
          dietPillsExperience.map((val, idx) => {
            if (val) formData.append('diet_pills_experience', String(idx + 1));
          });
          if (!dietPillsExperience[0]) {
            formData.append('diet_pills_level', String(dietPillsLevel));
            formData.append('diet_pills_side_effects', String(sideEffects));
          }
        }

        const response = await axiosClient.post('/func/order/poorder', formData);

        console.log('포트원 테스트 응답 성공:', response.data);
        //alert('포트원 요청 성공');

        const portone = new (window as any).PortOne({
          portOneKey : 'xsBNddPQwzfdKbDb',
          jwtToken : response.data.data.jwt
        });

        let payload = {
          merchant_details: {
            name:"US DIETDOCTOR",
            logo:"https://us.dietdr.co.kr/icons/favicon-96x96.png",
            back_url:"https://us.dietdr.co.kr/checkout",
            promo_code:"",
            promo_discount:0.0,
            shipping_charges:0.0
          },
          "shipping_details": {
            "shipping_name": deliveryName,
            "shipping_email": ordererEmail,
            "shipping_phone": deliveryTel,
            "shipping_address": {
              "locale": "en",
              "line_1": deliveryAddress1,
              "line_2": deliveryAddress2,
              "postal_code": zipCode,
            }
          },
          pmt_channel:"STRIPE",
          pmt_method: "STRIPE_CARD",
          merchant_order_id: response.data.data.order_id,
          signature_hash: response.data.data.signature,
          amount: (orderData!.total_discount_price_sum + deliveryPriceSum + orderData!.total_delivery_sum - totalDiscountPrice),
          currency:"USD",
          environment:"live",
          description:response.data.data.order_title,
          country_code:"US",
          expiry_hours:24,
          is_checkout_embed:false,
          show_back_button:true,
          show_shipping_details:false,
          default_guest_checkout:true,
          show_items:false,
          success_url:`https://us.dietdr.co.kr/orderConfirm/${response.data.data.order_id}/success`,
          failure_url:`https://us.dietdr.co.kr/orderConfirm/${response.data.data.order_id}/fail/999?error_message=ERROR_RETURN`,
          user_configured_field1: "ud",
        };
        console.info(payload)

        // 결제창 호출
        portone.checkoutService.checkout(payload);

      } catch (error) {
        console.error('포트원 테스트 응답 실패', error);
        alert('응답 생성 실패');
      }
      return;
    }
    
    orderData?.carts.map((company) => {
      company.cart.map((product) => {
        product.items.map((option) => {
          formData.append('cart_ids', String(option.id));
        });
      });
    });
    formData.append('order_name', ordererName);
    formData.append('order_email', ordererEmail);
    formData.append('order_phone', ordererTel);
    formData.append('address_name', deliveryName);
    formData.append('address_phone', deliveryTel);
    formData.append(
      'messanger',
      snsIdMethod === 'kakaotalk' ? `${snsIdMethod}__${deliverySnsId}` : '',
    );
    formData.append('address_zipcode', zipCode);
    formData.append('country_name', deliveryCountry);
    formData.append('address_state', deliveryState);
    formData.append('address_address1', deliveryAddress1);
    formData.append('address_address2', deliveryAddress2);
    formData.append('request_memo', deliveryMemo);
    formData.append('is_direct', isDirect!);
    formData.append('amount', String(orderData?.total_discount_price_sum));
    formData.append(
      'delivery',
      orderData?.total_delivery_sum === 0
        ? String(deliveryPriceSum)
        : String(orderData?.total_delivery_sum),
    );
    formData.append('use_point', String(usePoint));
    let sellerCouponTotalPrice =
      sellerCouponPrice !== 0
        ? sellerCouponPrice
        : sellerCouponPercent !== 0
        ? Math.floor(
            orderData.total_discount_price_sum * (sellerCouponPercent / 100),
          )
        : 0;
    let couponTotalPrice = useCoupon
      ? useCoupon.discount_type == 'price' //쿠폰 타입이 price이면
        ? useCoupon.discount_value // 단순 쿠폰 할인 금액을 추가하고,
        : useCoupon.discount_type == 'per' // 쿠폰 타입이 per이면
        ? Math.floor(
            (orderData.total_discount_price_sum - sellerCouponTotalPrice) *
              (useCoupon.discount_value / 100), //쿠폰 할인 %계산해서 추가
          )
        : 0
      : 0;
    let totalPromotionPrice =
      promotionPrice !== 0
        ? promotionPrice
        : promotionPercent !== 0
        ? Math.floor(
            (orderData.total_discount_price_sum -
              sellerCouponTotalPrice -
              couponTotalPrice) *
              (promotionPercent / 100),
          )
        : 0;
    if (sellerCouponPrice !== 0 || sellerCouponPercent !== 0) {
      formData.append('use_seller_coupon_code', sellerCoupon);
      formData.append(
        'use_seller_coupon_price',
        String(sellerCouponTotalPrice),
      );
    }
    if (useCoupon) {
      formData.append('use_coupon', String(useCoupon.id));
      formData.append('use_coupon_price', String(couponTotalPrice));
    }
    if (promotionPrice !== 0 || promotionPercent !== 0) {
      formData.append('use_promotion_code', promotion);
      formData.append('use_promotion_price', String(totalPromotionPrice));
    }

    formData.append(
      'total_amount_sum',
      String(
        orderData!.total_discount_price_sum +
          deliveryPriceSum +
          orderData!.total_delivery_sum -
          totalDiscountPrice,
      ),
    );
    // formData.append('pay_method', payMethod === 0 ? 'card' : 'paypal');
    // formData.append('pay_method', payMethod === 0 ? 'card' : 'foreign');
    formData.append('pay_method', payMethod === 0 ? 'card' : 'foreign');
    formData.append('pg', 'eximbay');
    if (needPrescription) {
      // formData.append('line_id', lineId);
      formData.append('user_name', patientName);
      formData.append('phone', patientTel);
      formData.append('social_number', patientBirth);
      formData.append('age', patientAge);
      formData.append('height', patientHeight);
      formData.append('weight', patientWeight);
      formData.append('is_pregnant', pregnancy ? 'Y' : 'N');
      formData.append('question', reason);
      formData.append('is_disease', disease ? 'Y' : 'N');
      formData.append('disease', diseaseDetail);
      formData.append('is_taking_medicines', medicine ? 'Y' : 'N');
      formData.append('taking_medicines', medicineDetail);
      formData.append('daily_coffee_intake', String(dailyCoffee));
      formData.append('caffeine_sensitivity', String(caffeineSensitivity));
      dietPillsExperience.map((val, idx) => {
        if (val) formData.append('diet_pills_experience', String(idx + 1));
      });
      if (!dietPillsExperience[0]) {
        formData.append('diet_pills_level', String(dietPillsLevel));
        formData.append('diet_pills_side_effects', String(sideEffects));
      }
    }
    // {orderData?.carts.map((company) =>
    //   company.cart.map((product) => ( product.product.product_id.includes(12))))
    // }

    // orderData?.carts.map((company) =>
    //   company.cart.map((product) => {
    //     if (
    //       product.product.product_id === 12 ||
    //       product.product.product_id === 13
    //     ) {
    //       ReactPixel.track('InitiateCheckout', {
    //         content_ids: product.product.product_id,
    //         content_type: 'product',
    //         value: String(
    //           orderData!.total_discount_price_sum +
    //             deliveryPriceSum +
    //             orderData!.total_delivery_sum -
    //             totalDiscountPrice,
    //         ),
    //         currency: 'USD',
    //       });

    //       TiktokPixel.track('InitiateCheckout', {
    //         value: String(
    //           orderData!.total_discount_price_sum +
    //             deliveryPriceSum +
    //             orderData!.total_delivery_sum -
    //             totalDiscountPrice,
    //         ),
    //         currency: 'USD',
    //         content_type: 'product',
    //         content_id: product.product.product_id,
    //         content_name: product.product.title,
    //       });
    //     }
    //   }),
    // );

    let contentIds: any[] = [];
    let contentNames: any[] = [];

    orderData?.carts.forEach((company) => {
      company.cart.forEach((product) => {
        if (tagNum.some((num) => product.product.product_id === num)) {
          contentIds.push(product.product.product_id);
          contentNames.push(product.product.title);
        }
      });
    });

    if (contentIds.length > 0) {
      const value = String(
        orderData!.total_discount_price_sum +
          deliveryPriceSum +
          orderData!.total_delivery_sum -
          totalDiscountPrice,
      );

      const contents = contentIds.map((id, index) => ({
        content_id: id,
        content_name: contentNames[index],
      }));

      // const contentIdsString = contentIds.join(',');
      // const contentNamesString = contentNames.join(',');

      TiktokPixel.track('InitiateCheckout', {
        value: value,
        currency: 'USD',
        content_type: 'product',
        contents: contents,
        event_id: cartId,
        // content_id: contentIdsString,
        // content_name: contentNamesString,
      });

      const obj = {
        event_source: 'web',
        event_source_id: tiktokID,
        data: [
          {
            evnet: 'InitiateCheckout',
            event_id: cartId,
            evnet_time: new Date().getTime(),
            properties: {
              value: value,
              currency: 'USD',
              content_type: 'product',
              contents: contents,
            },
            page: {
              url: window.location.href,
            },
            user: {
              ip: ip,
              user_agent: navigator.userAgent.toLowerCase(),
            },
          },
        ],
      };

      axios
        .post(
          'https://business-api.tiktok.com/open_api/v1.3/event/track',
          obj,
          {
            headers: {
              'Access-Token': '0dfad9829093a6e2a95c9c8409ee1025e76b13eb',
              // Authorization: `Bearer 0dfad9829093a6e2a95c9c8409ee1025e76b13eb`,
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin': '*',
            },
          },
        )
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    }

    // let values: any = formData.entries();
    // for (const [key, pair] of values) {
    //   console.log(key + '/' + pair);
    // }
    let isError = false;
    
    fbq('track', 'InitiateCheckout', {
      content_ids: orderData.carts[0].cart[0].product.product_id,
      content_type: 'product',
      currency: 'USD',
    });
    
    let createOrderResult = await axiosClient
      .post('/func/order', formData)
      .then((res) => {
        return res.data.data;
      })
      .catch((err) => {
        if (err) alert(err.response.data.detail);
        isError = true;
      });
    if (isError) {
      navigate('/basket');
    }

    window.location.href = `${createOrderResult.payurl}`;

    // if (payMethod === 0) {
    //   // payplePay(createOrderResult);
    //   eximbayPay(createOrderResult.request_body);
    // }
    // if (payMethod === 1) {
    //   eximbayPay(createOrderResult.request_body);
    // }
    // else if (payMethod == 1) eximbayPay(createOrderResult.order_id);
  };

  async function eximbayPay(request: any) {
    saveInfo();
    setIsSubmitting(false);
    (window as any).EXIMBAY.request_pay(request);
  }

  // 구매 버튼 눌렀을 때
  async function handleSubmit() {
    if (isSubmitting) return;
    setIsSubmitting(true);
    const isOk = checkValidate();
    if (!isOk) {
      setIsSubmitting(false);
      return;
    }
    //페이팔버튼 false면 약관 동의 다 한거 그래서 true로 확인
    if (paypalBtn) {
      setIsSubmitting(false);
      return alert(t('other.23'));
    }

    await handleClick();
    setIsSubmitting(false);
  }
  // 구매 버튼 눌렀을 때
  // 질환, 약 여부 체크
  const [disease, setDisease] = useState<boolean>();
  const [medicine, setMedicine] = useState<boolean>();
  const [diseaseDetail, setDiseaseDetail] = useState('');
  const [medicineDetail, setMedicineDetail] = useState('');
  // 질환, 약 여부 체크
  const [orderData, setOrderData] = useState<IBasketDataType>();

  // 상품 총 갯수
  const [totalCnt, setTotalCnt] = useState(0);
  const [deliveryPriceSum, setDeliveryPriceSum] = useState(0);
  useEffect(() => {
    if (!cartId || !isDirect) return;
    let itemIdList: number[] = JSON.parse(cartId);
    let queryString = `is_direct=${isDirect}`;
    itemIdList.map((id) => {
      queryString += `&cart_ids=${id}`;
    });
    axiosClient.get(`/data/cart?${queryString}`).then((res) => {
      if (res.data.data.carts.length == 0) {
        alert(t('other.30'));
        navigate('/basket');
      }
      setOrderData(res.data.data);
      setTotalCnt(res.data.total_ea_sum);
      setDeliveryPriceSum(res.data.delivery_price_sum);
      try {
        for (let i = 0; i < res.data.data.carts.length; i++) {
          let needPrescription = false;
          for (let j = 0; j < res.data.data.carts[i].cart.length; j++) {
            if (res.data.data.carts[i].cart[j].product.is_prescription == 1) {
              //처방전 필요한 주문건인지 체크
              needPrescription = true;
            }
          }
          if (needPrescription) {
            setNeedPrescription(true);
            break;
          }
        }
      } catch (err: any) {
        alert(err.response.data.detail);
      }
    });
  }, []);

  function productOptionCal(product: IBasketProductType) {
    let data = { price: 0, count: 0 };
    product.items.map((option) => {
      data.price += option.discount_price * option.count;
      data.count += option.count;
    });
    return data;
  }
  useEffect(() => {
    try {
      const temporaryOrderInfo = JSON.parse(
        sessionStorage.getItem('temporaryOrderInfo') || JSON.stringify(''),
      ); //결제 페이지 넘어가기 전 저장해둔 작성 정보, 결제 페이지에서 뒤로가기를 눌러 돌아왔을 때 저장된 정보 가져와서 다시 입력해줌
      const patientState = location.state; //문진표 페이지에서 넘어온 state
      // console.log(patientState);
      console.log(patientState);
      if (patientState) {
        // setLineId(patientState.lineId);
        setPatientName(patientState.patientName);
        setPatientTel(patientState.patientTel);
        setPatientBirth(patientState.patientBirth);
        setPatientAge(patientState.patientAge);
        setPatientHeight(patientState.patientHeight);
        setPatientWeight(patientState.patientWeight);
        setReason(patientState.reason);
        setPregnancy(patientState.pregnancy);
        setDailyCoffee(patientState.dailyCoffee);
        setCaffeineSensitivity(patientState.caffeineSensitivity);
        setDietPillsExperience(patientState.dietPillsExperience);
        setDietPillsLevel(patientState.dietPillsLevel);
        setSideEffects(patientState.sideEffects || '');
        setDisease(patientState.disease);
        setDiseaseDetail(patientState.diseaseDetail);
        setMedicine(patientState.medicine);
        setMedicineDetail(patientState.medicineDetail);
      } else if (temporaryOrderInfo) {
        // setLineId(temporaryOrderInfo.lineId);
        if (nameRegex.test(temporaryOrderInfo.ordererName))
          setOrdererName(temporaryOrderInfo.ordererName);
        setOrdererEmail(temporaryOrderInfo.ordererEmail);
        setOrdererTel(temporaryOrderInfo.ordererTel);
        setPatientName(temporaryOrderInfo.patientName);
        setPatientTel(temporaryOrderInfo.patientTel);
        setPatientBirth(temporaryOrderInfo.patientBirth);
        setPatientAge(temporaryOrderInfo.patientAge);
        setPatientHeight(temporaryOrderInfo.patientHeight);
        setPatientWeight(temporaryOrderInfo.patientWeight);
        setReason(temporaryOrderInfo.reason);
        setPregnancy(temporaryOrderInfo.pregnancy);
        setCaffeineSensitivity(temporaryOrderInfo.caffeineSensitivity);
        setDailyCoffee(temporaryOrderInfo.dailyCoffee);
        setDietPillsExperience(temporaryOrderInfo.dietPillsExperience);
        setDietPillsLevel(temporaryOrderInfo.dietPillsLevel);
        setSideEffects(temporaryOrderInfo.sideEffects);
        setDisease(temporaryOrderInfo.disease);
        setDiseaseDetail(temporaryOrderInfo.diseaseDetail);
        setMedicine(temporaryOrderInfo.medicine);
        setMedicineDetail(temporaryOrderInfo.medicineDetail);
        setMedicineDetail(temporaryOrderInfo.deliverySnsId);
        if (nameRegex.test(temporaryOrderInfo.deliveryName))
          setDeliveryName(temporaryOrderInfo.deliveryName);
        setDeliveryTel(temporaryOrderInfo.deliveryTel);
        setZipCode(temporaryOrderInfo.zipCode);
        setDeliveryAddress1(temporaryOrderInfo.deliveryAddress1);
        setDeliveryAddress2(temporaryOrderInfo.deliveryAddress2);
        setDeliveryMemo(temporaryOrderInfo.deliveryMemo);
        setPayMethod(temporaryOrderInfo.payMethod);
        setEximbayAgencyCode(temporaryOrderInfo.eximbayAgencyCode);
        setPayAgree(true);
        setPrivacyAgree(true);
        setDiagnosisAgree(true);
      }
      sessionStorage.removeItem('temporaryOrderInfo');
    } catch (err) {
      sessionStorage.removeItem('temporaryOrderInfo');
      alert(t('other.31'));
      navigate('/');
    }
    const token = localStorage.getItem('token');
    if (!token || token == null || token == undefined || token == 'null')
      return;
    try {
      const userInfo: ITokenInfoType = jwt_decode(token!);
      if (nameRegex.test(userInfo.name)) {
        setOrdererName(userInfo.name);
        setDeliveryName(userInfo.name);
      }
      setOrdererTel(userInfo.phone);
      setDeliveryTel(userInfo.phone);
      setOrdererEmail(userInfo.email);
    } catch (err) {
      logout();
    }
  }, []);
  const { t, i18n } = useTranslation();

  const paypalIdRef = useRef('');
  const handleCheck = () => {
    if (isSubmitting) return;
    setIsSubmitting(true);

    const isOk = checkValidate();
    if (!isOk) {
      setIsSubmitting(false);
      return false;
    }
    setIsSubmitting(false);

    return true;
  };

  useEffect(() => {
    if (payAgree && privacyAgree && diagnosisAgree) setPaypalBtn(false);
    else setPaypalBtn(true);
  }, [payAgree, privacyAgree, diagnosisAgree]);

  useEffect(() => {
    if (!paypalBtn) {
      setPaypalBtn(true);
      setPayAgree(false);
      setPrivacyAgree(false);
      setDiagnosisAgree(false);
    }
  }, [
    ordererName,
    ordererEmail,
    ordererTel,
    deliveryName,
    deliveryTel,
    deliverySnsId,
    snsIdMethod,
    zipCode,
    // deliveryState,
    deliveryAddress1,
    deliveryAddress2,
  ]);

  const handleCreateOrder = async (actions: any) => {
    if (!orderData) return 'INVALID_REQUEST';
    let formData = new FormData();

    orderData?.carts.map((company: any) => {
      company.cart.map((product: any) => {
        product.items.map((option: any) => {
          formData.append('cart_ids', String(option.id));
        });
      });
    });
    formData.append('order_name', ordererName);
    formData.append('order_email', ordererEmail);
    formData.append('order_phone', ordererTel);
    formData.append('address_name', deliveryName);
    formData.append('address_phone', deliveryTel);
    formData.append(
      'messanger',
      snsIdMethod === 'kakaotalk' ? `${snsIdMethod}__${deliverySnsId}` : '',
    );
    formData.append('address_zipcode', zipCode);
    formData.append('country_name', deliveryCountry);
    formData.append('address_state', deliveryState);
    formData.append('address_address1', deliveryAddress1);
    formData.append('address_address2', deliveryAddress2);
    formData.append('request_memo', deliveryMemo);
    formData.append('is_direct', isDirect!);
    formData.append('amount', String(orderData?.total_discount_price_sum));
    // formData.append(
    //   'delivery',
    //   orderData?.total_delivery_sum === 0
    //     ? String(deliveryPrice)
    //     : String(orderData?.total_delivery_sum),
    // );
    formData.append(
      'delivery',
      orderData?.total_delivery_sum === 0
        ? String(deliveryPriceSum)
        : String(orderData?.total_delivery_sum),
    );
    formData.append('use_point', String(usePoint));
    let sellerCouponTotalPrice =
      sellerCouponPrice !== 0
        ? sellerCouponPrice
        : sellerCouponPercent !== 0
        ? Math.floor(
            orderData.total_discount_price_sum * (sellerCouponPercent / 100),
          )
        : 0;
    let couponTotalPrice = useCoupon
      ? useCoupon.discount_type == 'price' //쿠폰 타입이 price이면
        ? useCoupon.discount_value // 단순 쿠폰 할인 금액을 추가하고,
        : useCoupon.discount_type == 'per' // 쿠폰 타입이 per이면
        ? Math.floor(
            (orderData.total_discount_price_sum - sellerCouponTotalPrice) *
              (useCoupon.discount_value / 100), //쿠폰 할인 %계산해서 추가
          )
        : 0
      : 0;
    let totalPromotionPrice =
      promotionPrice !== 0
        ? promotionPrice
        : promotionPercent !== 0
        ? Math.floor(
            (orderData.total_discount_price_sum -
              sellerCouponTotalPrice -
              couponTotalPrice) *
              (promotionPercent / 100),
          )
        : 0;
    if (sellerCouponPrice !== 0 || sellerCouponPercent !== 0) {
      formData.append('use_seller_coupon_code', sellerCoupon);
      formData.append(
        'use_seller_coupon_price',
        String(sellerCouponTotalPrice),
      );
    }
    if (useCoupon) {
      formData.append('use_coupon', String(useCoupon.id));
      formData.append('use_coupon_price', String(couponTotalPrice));
    }
    if (promotionPrice !== 0 || promotionPercent !== 0) {
      formData.append('use_promotion_code', promotion);
      formData.append('use_promotion_price', String(totalPromotionPrice));
    }

    // formData.append(
    //   'total_amount_sum',
    //   String(
    //     orderData!.total_discount_price_sum +
    //       deliveryPrice +
    //       orderData!.total_delivery_sum -
    //       totalDiscountPrice,
    //   ),
    // );
    formData.append(
      'total_amount_sum',
      String(
        orderData!.total_discount_price_sum +
          deliveryPriceSum +
          orderData!.total_delivery_sum -
          totalDiscountPrice,
      ),
    );
    formData.append('pay_method', 'paypal');
    formData.append('pg', 'eximbay');
    if (needPrescription) {
      // formData.append('line_id', lineId);
      formData.append('user_name', patientName);
      formData.append('phone', patientTel);
      formData.append('social_number', patientBirth);
      formData.append('age', patientAge);
      formData.append('height', patientHeight);
      formData.append('weight', patientWeight);
      formData.append('is_pregnant', pregnancy ? 'Y' : 'N');
      formData.append('question', reason);
      formData.append('is_disease', disease ? 'Y' : 'N');
      formData.append('disease', diseaseDetail);
      formData.append('is_taking_medicines', medicine ? 'Y' : 'N');
      formData.append('taking_medicines', medicineDetail);
      formData.append('daily_coffee_intake', String(dailyCoffee));
      formData.append('caffeine_sensitivity', String(caffeineSensitivity));
      dietPillsExperience.map((val, idx) => {
        if (val) formData.append('diet_pills_experience', String(idx + 1));
      });
      if (!dietPillsExperience[0]) {
        formData.append('diet_pills_level', String(dietPillsLevel));
        formData.append('diet_pills_side_effects', String(sideEffects));
      }
    }

    // let values: any = formData.entries();
    // for (const [key, pair] of values) {
    //   console.log(key + '/' + pair);
    // }
    return axiosClient
      .post('/func/order', formData)
      .then((res) => {
        fbq('track', 'InitiateCheckout', {
          content_ids: orderData.carts[0].cart[0].product.product_id,
          content_type: 'product',
          currency: 'USD',
        });

        paypalIdRef.current = res.data.data.paypal_order_id;
        return res.data.data.paypal_order_id;
      })
      .catch((err) => {
        return err;
      });
  };

  const handleOnApprove = () => {
    return axiosClient
      .post('/func/order/paypal-order-callback', {
        params: { paypalOrderId: paypalIdRef.current },
      })
      .then((res) => {
        if (res.data.data.status === 'fail') {
          if (res.data.data.isFailed && res.data.data.isFailed == 'TS21')
            alert(
              'The card is not registered with the 3DS. Please contact your card company or issuing bank branch.',
            );
          else alert(res.data.data.message);
          let url = sessionStorage.getItem('lastOrderPageUrl');
          if (url) navigate(url);
          else navigate('/');
        } else if (res.data.data.status == 'success') {
          sessionStorage.removeItem('temporaryOrderInfo');
          navigate(`/orderComplete/${res.data.data.order_id}`);
        }
      })
      .catch((err) => {
        return err;
      });
  };

  const handleCancel = () => {
    return alert('The payment was cancelled.');
  };

  const handleError = () => {
    return navigate('/basket');
  };

  return (
    <div className={`${styles.container} ${isDesktop ? styles.pcVersion : ''}`}>
      <LoginHandler />
      {isDesktop && <Header />}
      <div className={styles.header}>
        <img src={leftArrow} alt="arrow" onClick={() => navigate(-1)} />
        <span>{t('order.1')}</span>
      </div>
      <div className={styles.orderForm}>
        <div className={styles.left}>
          <div className={styles.productListWrap}>
            {orderData?.carts.map((company) =>
              company.cart.map((product) => (
                <div
                  className={styles.productInfoWrap}
                  key={product.product.product_id}
                >
                  <div className={styles.thumbnailWrap}>
                    <img src={product.product.list_image} alt="thumbnail" />
                  </div>
                  <div className={styles.productInfo}>
                    <h3 className={styles.productName}>
                      {product.product.title}
                    </h3>
                    <ul className={styles.optionList}>
                      {product.product.option_depth > 0 &&
                        product.items.map((option) => (
                          <li key={option.id}>
                            <span>
                              {option.option1 && option.option1}
                              {option.option2 && ' / ' + option.option2}
                              {option.option3 && ' / ' + option.option3}
                            </span>
                            <span>
                              {t('order.2')} {option.count}
                            </span>
                          </li>
                        ))}
                    </ul>
                    <div className={styles.totalInfoWrap}>
                      {(() => {
                        let res = productOptionCal(product);
                        return (
                          <>
                            <span>${res.price.toLocaleString()}</span>
                            <span>
                              {t('order.2')} {res.count}
                            </span>
                          </>
                        );
                      })()}
                    </div>
                  </div>
                </div>
              )),
            )}
          </div>
          <div className={styles.ordererInfoWrap}>
            <h3 className={styles.sectionHeader}>{t('order.3')}</h3>
            <form
              className={styles.ordererInfoForm}
              onSubmit={(e) => e.preventDefault()}
            >
              <label className={styles.label}>
                <div className={styles.labelWrap}>
                  <span>*</span>
                  <span>{t('order.4')}</span>
                </div>
                <div
                  className={`${styles.inputWrap} ${
                    validation.ordererName ? styles.validationError : ''
                  }`}
                >
                  <input
                    type="text"
                    placeholder={`${t('order.4')}`}
                    className={styles.normalInput}
                    value={ordererName}
                    onChange={(e) => setOrdererName(e.currentTarget.value)}
                    onBlur={() => setOrdererName((prev) => prev.trim())}
                  />
                </div>
              </label>
              <label className={styles.label}>
                <div className={styles.labelWrap}>
                  <span>*</span>
                  <span>{t('order.5')}</span>
                </div>
                <div
                  className={`${styles.inputWrap} ${
                    validation.ordererEmail ? styles.validationError : ''
                  }`}
                >
                  <input
                    type="text"
                    placeholder="ondoc@gmail.com"
                    className={styles.normalInput}
                    value={ordererEmail}
                    onChange={(e) => setOrdererEmail(e.currentTarget.value)}
                    onBlur={() => setOrdererEmail((prev) => prev.trim())}
                  />
                </div>
              </label>
              <label className={styles.label}>
                <div className={styles.labelWrap}>
                  <span>*</span>
                  <span>{t('order.6')}</span>
                </div>
                <div
                  className={`${styles.inputWrap} ${
                    validation.ordererTel ? styles.validationError : ''
                  }`}
                >
                  <input
                    type="text"
                    placeholder=""
                    className={styles.normalInput}
                    value={ordererTel}
                    onChange={(e) => {
                      const value = e.currentTarget.value;
                      if (phoneRegex.test(value)) setOrdererTel(value);
                      // if (isNaN(Number(value)) && value !== '+') return;
                      // setOrdererTel(value);
                    }}
                    onBlur={() => {
                      setOrdererTel((prev) => prev.replace(/-/gi, '').trim());
                    }}
                  />
                </div>
              </label>
            </form>
          </div>
          <div className={styles.deliveryInfoWrap}>
            <h3>{t('order.7')}</h3>
            <form onSubmit={(e) => e.preventDefault()}>
              <label className={styles.label}>
                <div className={styles.labelWrap}>
                  <span>*</span>
                  <span>{t('order.8')}</span>
                </div>
                <div
                  className={`${styles.inputWrap} ${
                    validation.deliveryName ? styles.validationError : ''
                  }`}
                >
                  <input
                    type="text"
                    placeholder={`${t('order.8')}`}
                    className={styles.normalInput}
                    value={deliveryName}
                    onChange={(e) => setDeliveryName(e.currentTarget.value)}
                    onBlur={() => setDeliveryName((prev) => prev.trim())}
                  />
                </div>
              </label>
              <label className={styles.label}>
                <div className={styles.labelWrap}>
                  <span>*</span>
                  <span>{t('order.6')}</span>
                </div>
                <div
                  className={`${styles.inputWrap} ${
                    validation.deliveryTel ? styles.validationError : ''
                  }`}
                >
                  <input
                    type="text"
                    placeholder=""
                    className={styles.normalInput}
                    value={deliveryTel}
                    onChange={(e) => {
                      const value = e.currentTarget.value;
                      if (phoneRegex.test(value)) setDeliveryTel(value);
                      // if (isNaN(Number(value)) && value !== '+') return;
                      // setDeliveryTel(value);
                    }}
                    onBlur={() => {
                      setDeliveryTel((prev) => prev.replace(/-/gi, '').trim());
                    }}
                  />
                </div>
              </label>
              {/* <div className={styles.addressWrap}>
                <div className={styles.addressLabel}>
                  <span>*</span>
                  <span>{t('order.47')}</span>
                </div>
                <div className={styles.zipCode}>
                  <div
                    className={`${styles.inputWrap} ${
                      validation.zipCode ? styles.validationError : ''
                    }`}
                  >
                    {' '}
                    <input
                      type="text"
                      placeholder={`例) 123-4567`}
                      value={zipCode}
                      onChange={(e) => {
                        let value = e.currentTarget.value;
                        if (!zipCodeRegex.test(value)) return;
                        setZipCode(value);
                      }}
                      onBlur={() => setZipCode((prev) => prev.trim())}

                      // readOnly
                    />
                  </div>
                  <div onClick={searchZipCode} className={styles.addressSearch}>
                    検索
                  </div>
                </div>
              </div> */}
              {/* <label className={`${styles.label} ${styles.deliveryAddress}`}>
                <div className={styles.labelWrap}>
                  <span>*</span>
                  <span>{t('order.48')}</span>
                </div>
                <div className={styles.inputWrap}>
                  <div
                    className={`${styles.prefectureSelectWrap} ${
                      validation.deliveryAddress1 ? styles.validationError : ''
                    }`}
                  >
                    <select
                      onChange={(e) =>
                        setDeliveryAddress1(e.currentTarget.value)
                      }
                      value={deliveryAddress1}
                    >
                      <option value="" disabled selected>
                        選択してください
                      </option>
                      {prefecture.map((pre) => (
                        <option value={pre} key={pre}>
                          {pre}
                        </option>
                      ))}
                    </select>
                    <img src={selectOpen} alt="selectOpen" />
                  </div>
                </div>
              </label> 
              </label>*/}
              <div
                className={`${styles.snsTypeWrap} ${
                  isMobile ? styles.isMobile : ''
                }`}
              >
                <div className={styles.snsTitle}>
                  <span>*</span>
                  <span>Sns id</span>
                </div>
                <div className={styles.customCheckBoxList}>
                  <div
                    className={`${styles.customCheckBoxWrap} ${
                      snsIdMethod === 'kakaotalk' ? styles.hit : ''
                    }`}
                    onClick={() => {
                      setSnsIdMethod('kakaotalk');
                      if (snsIdMethod !== 'kakaotalk') setDeliverySnsId('');
                    }}
                  >
                    <div className={styles.customCheckBox}></div>
                    <span>KakaoTalk ID</span>
                  </div>
                  {/* <div
                    className={`${styles.customCheckBoxWrap} ${
                      snsIdMethod === 'whatsapp' ? styles.hit : ''
                    }`}
                    onClick={() => {
                      setSnsIdMethod('whatsapp');
                      if (snsIdMethod !== 'whatsapp') setDeliverySnsId('');
                    }}
                  >
                    <div className={styles.customCheckBox}></div>
                    <span>WhatsApp ID</span>
                  </div> */}
                </div>
              </div>
              <label className={styles.label}>
                <div className={styles.labelWrap}></div>
                <div
                  className={`${styles.inputWrap} ${
                    validation.deliverySnsId ? styles.validationError : ''
                  }`}
                >
                  <input
                    type="text"
                    placeholder="Kakaotalk ID"
                    className={styles.normalInput}
                    value={deliverySnsId}
                    onChange={(e) => setDeliverySnsId(e.currentTarget.value)}
                  />
                </div>
              </label>
              <label className={`${styles.label} ${styles.deliveryAddress}`}>
                <div className={styles.labelWrap}>
                  <span>*</span>
                  <span>{t('order.55')}</span>
                </div>
                <div className={styles.inputWrap}>
                  <div
                    className={`${styles.prefectureSelectWrap} ${
                      validation.deliveryCountry ? styles.validationError : ''
                    }`}
                  >
                    <select
                      defaultValue="defaultState"
                      onChange={(e) =>
                        setDeliveryCountry(e.currentTarget.value)
                      }
                    >
                      <option value="defaultState" disabled>
                        {t('order.56')}
                      </option>
                      {countryData.map((country) => (
                        <option value={country} key={country}>
                          {country}
                        </option>
                      ))}
                    </select>
                    <img src={selectOpen} alt="selectOpen" />
                  </div>
                </div>
              </label>
              <label className={`${styles.label} ${styles.deliveryAddress}`}>
                <div className={styles.labelWrap}>
                  <span>*</span>
                  <span>{t('order.51')}</span>
                </div>
                <div className={styles.inputWrap}>
                  <div
                    className={`${styles.prefectureSelectWrap} ${
                      validation.deliveryState ? styles.validationError : ''
                    }`}
                  >
                    <select
                      defaultValue="defaultState"
                      onChange={(e) => setDeliveryState(e.currentTarget.value)}
                    >
                      <option value="defaultState" disabled>
                        State
                      </option>
                      {stateArray.map((state) => (
                        <option value={state} key={state}>
                          {state}
                        </option>
                      ))}
                    </select>
                    <img src={selectOpen} alt="selectOpen" />
                  </div>
                </div>
              </label>
              <label className={`${styles.label} ${styles.deliveryAddress}`}>
                <div className={styles.labelWrap}>
                  <span>*</span>
                  <span>{t('order.48')}</span>
                </div>
                <div
                  className={`${styles.inputWrap} ${
                    validation.deliveryAddress1 ? styles.validationError : ''
                  }`}
                >
                  <input
                    type="text"
                    placeholder={`ex) 123 Main Street. #101`}
                    className={styles.normalInput}
                    value={deliveryAddress1}
                    onChange={(e) => setDeliveryAddress1(e.currentTarget.value)}
                  />
                </div>
              </label>
              <label className={`${styles.label} ${styles.deliveryAddress}`}>
                <div className={styles.labelWrap}>
                  <span>*</span>
                  <span>{t('order.49')}</span>
                </div>
                <div
                  className={`${styles.inputWrap} ${
                    validation.deliveryAddress2 ? styles.validationError : ''
                  }`}
                >
                  <input
                    type="text"
                    placeholder={`ex) Anytown, CA`}
                    className={styles.normalInput}
                    value={deliveryAddress2}
                    onChange={(e) => setDeliveryAddress2(e.currentTarget.value)}
                  />
                </div>
              </label>

              <label className={`${styles.label} ${styles.deliveryAddress}`}>
                <div className={styles.labelWrap}>
                  <span>*</span>
                  <span>{t('order.47')}</span>
                </div>
                <div
                  className={`${styles.inputWrap} ${
                    validation.zipCode ? styles.validationError : ''
                  }`}
                >
                  <input
                    type="text"
                    placeholder={`ex) 92802 or 73501 - 1357`}
                    className={styles.normalInput}
                    value={zipCode}
                    // onChange={(e) => setZipCode(e.currentTarget.value)}
                    onChange={(e) => {
                      let value = e.currentTarget.value;
                      setZipCode(value);
                    }}
                  />
                </div>
              </label>
              <label className={`${styles.label} ${styles.deliveryMemo}`}>
                <div className={styles.labelWrap}>
                  <span></span>
                  <span>{t('order.13')}</span>
                </div>
                <div className={styles.inputWrap}>
                  <input
                    type="text"
                    placeholder={`${t('order.14')}`}
                    className={styles.normalInput}
                    value={deliveryMemo}
                    onChange={(e) => setDeliveryMemo(e.currentTarget.value)}
                  />
                </div>
              </label>
              <label
                style={{
                  color: 'rgba(19, 28, 49, 0.5)',
                  fontWeight: '600',
                }}
                className={`${styles.label} ${styles.deliveryAddress}`}
              >
                It takes about 4 days for delivery after the order is completed.
              </label>
            </form>
          </div>
          {isDesktop && (
            <div className={styles.discountInfoWrap}>
              <h3
                className={styles.sectionHeader}
                onClick={() => setDiscountInfoOpen((prev) => !prev)}
              >
                <span>{t('order.15')}</span>
              </h3>
              {(discountInfoOpen || isDesktop) && (
                <div className={styles.content}>
                  <div className={styles.savings}>
                    <div>
                      <span>
                        {t('order.16')} ${userPoint.toLocaleString()}
                      </span>
                      <span>{/* 1,000원 이상 보유 시 사용가능 */}</span>
                    </div>
                    <div>
                      <input
                        type="text"
                        placeholder="$0"
                        value={point}
                        pattern="[0-9]*"
                        onChange={(e) => {
                          // setUsePoint(0);
                          if (isNaN(Number(e.currentTarget.value))) return;
                          if (Number(e.currentTarget.value) < 0) setPoint(0);
                          else if (Number(e.currentTarget.value) > userPoint)
                            setPoint(userPoint);
                          else {
                            setPoint(Number(e.currentTarget.value));
                          }
                        }}
                      />
                      <div onClick={pointApply}>{t('order.18')}</div>
                    </div>
                  </div>
                  {/* <div
                    className={styles.couponBtn}
                    onClick={() => setCouponModalOpen(true)}
                  >
                    <span>
                      {t('order.17')}{' '}
                      {
                        <>
                          {
                            couponList.filter((coupon) => coupon.status == 'N')
                              .length
                          }
                        </>
                      }
                      枚
                    </span>
                    <img src={rightArrow} alt="arrow" />
                  </div> */}
                  {/* <div className={styles.promotion}>
                    <div>
                      <span>{t('order.19')}</span>
                    </div>
                    <div>
                      <input
                        type="text"
                        placeholder=""
                        value={promotion}
                        onChange={(e) => {
                          setPromotion(e.currentTarget.value);
                          setPromotionPercent(0);
                          setPromotionPrice(0);
                        }}
                      />
                      <div onClick={checkPromotion}>{t('order.18')}</div>
                    </div>
                  </div> */}
                  <div className={styles.sellerCoupon}>
                    <div>
                      <span>{t('order.46')}</span>
                    </div>
                    <div>
                      <input
                        type="text"
                        placeholder=""
                        value={sellerCoupon}
                        onChange={(e) => {
                          setSellerCoupon(e.currentTarget.value);
                          setSellerCouponPercent(0);
                          setSellerCouponPrice(0);
                        }}
                      />
                      <div onClick={checkSellerCoupon}>{t('order.18')}</div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
          {/* <ul className={styles.priceGuideList}>
            <li>
              ·무이자할부가 적용되지 않은 상품과 무이자할부가 가능한 상품을
              동시에 구매할 경우 전체 주문 상품 금액에 대해 무이자할부가
              적용되지 않습니다.
            </li>
            <li>
              ·무이자할부를 원하시는 경우 장바구니에서 무이자할부 상품만
              선택하여 주문하여 주시기 바랍니다.
            </li>
            <li>
              ·최소 결제 가능 금액은 결제금액에서 배송비를 제외한 금액입니다.
            </li>
          </ul> */}
        </div>
        <div className={styles.right}>
          <div className={styles.totalPriceInfoWrap}>
            <h3 className={styles.sectionHeader}>{t('order.30')}</h3>
            <div className={styles.productPrice}>
              <span>{t('order.31')}</span>
              <span>$ {orderData?.total_price_sum.toLocaleString()}</span>
            </div>
            <div className={styles.discountPrice}>
              <span>{t('order.32')}</span>
              <span>$ {<>{totalDiscountPrice.toLocaleString()}</>}</span>
            </div>
            <div className={styles.deliveryPrice}>
              <span>{t('order.33')}</span>
              <span>
                {orderData?.total_delivery_sum === 0
                  ? deliveryPriceSum !== 0
                    ? '$ ' + deliveryPriceSum.toLocaleString()
                    : t('order.34')
                  : '$ ' + orderData?.total_delivery_sum.toLocaleString()}
              </span>
            </div>
            <div className={styles.totalPrice}>
              <span>{t('order.30')}</span>
              <span>
                $
                {orderData &&
                  (
                    orderData?.total_discount_price_sum +
                    deliveryPriceSum +
                    orderData?.total_delivery_sum -
                    totalDiscountPrice
                  ).toLocaleString()}
              </span>
            </div>
          </div>
          {!isDesktop && (
            <div className={styles.discountInfoWrap}>
              <h3
                className={styles.sectionHeader}
                onClick={() => setDiscountInfoOpen((prev) => !prev)}
              >
                <span>{t('order.15')}</span>
                <img
                  src={bottomArrow}
                  alt="arrow"
                  style={{
                    transform: `rotate(${discountInfoOpen ? '180deg' : '0'})`,
                  }}
                />
              </h3>
              {discountInfoOpen && (
                <div className={styles.content}>
                  <div className={styles.savings}>
                    <div>
                      <span>
                        {t('order.16')} ${userPoint.toLocaleString()}
                      </span>
                      <span>{/* 1,000원 이상 보유 시 사용가능 */}</span>
                    </div>
                    <div>
                      <input
                        type="text"
                        placeholder="$0"
                        value={point}
                        pattern="[0-9]*"
                        onChange={(e) => {
                          // setUsePoint(0);
                          if (isNaN(Number(e.currentTarget.value))) return;
                          if (Number(e.currentTarget.value) < 0) setPoint(0);
                          else if (Number(e.currentTarget.value) > userPoint)
                            setPoint(userPoint);
                          else {
                            setPoint(Number(e.currentTarget.value));
                          }
                        }}
                      />
                      <div onClick={pointApply}>{t('order.18')}</div>
                    </div>
                  </div>
                  {/* <div
                    className={styles.couponBtn}
                    onClick={() => setCouponModalOpen(true)}
                  >
                    <span>
                      {t('order.17')}{' '}
                      {
                        <>
                          {
                            couponList.filter((coupon) => coupon.status == 'N')
                              .length
                          }
                        </>
                      }
                      枚
                    </span>
                    <img src={rightArrow} alt="arrow" />
                  </div>
                  <div className={styles.promotion}>
                    <div>
                      <span>{t('order.19')}</span>
                    </div>
                    <div>
                      <input
                        type="text"
                        placeholder=""
                        value={promotion}
                        onChange={(e) => {
                          setPromotion(e.currentTarget.value);
                          setPromotionPercent(0);
                          setPromotionPrice(0);
                        }}
                      />
                      <div onClick={checkPromotion}>{t('order.18')}</div>
                    </div>
                  </div> */}
                  <div className={styles.sellerCoupon}>
                    <div>
                      <span>{t('order.46')}</span>
                    </div>
                    <div>
                      <input
                        type="text"
                        placeholder=""
                        value={sellerCoupon}
                        onChange={(e) => {
                          setSellerCoupon(e.currentTarget.value);
                          setSellerCouponPercent(0);
                          setSellerCouponPrice(0);
                        }}
                      />
                      <div onClick={checkSellerCoupon}>{t('order.18')}</div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
          <div className={styles.payMethodWrap}>
            <h3 className={styles.sectionHeader}>{t('order.35')}</h3>
            <ul className={styles.payMethodList}>
              {/* <li
                className={payMethod === 0 ? styles.hit : ''}
                onClick={() => {
                  setPayMethod(0);
                  // setEximbayAgencyCode('P000');
                }}
              >
                <div className={styles.customCheckBox}></div>
                <span>{t('order.53')}</span>
              </li> */}
              <li
                className={payMethod === 1 ? styles.hit : ''}
                onClick={() => {
                  setPayMethod(1);
                }}
              >
                <div className={styles.customCheckBox}></div>
                <span>{t('order.54')}</span>
              </li>
              <li
                className={payMethod === 2 ? styles.hit : ''}
                onClick={() => {
                  setPayMethod(2);
                }}
              >
                <div className={styles.customCheckBox}></div>
                <span>{t('order.52')}</span>
              </li>
            </ul>
          </div>

          <ul className={styles.agreementList}>
            <li>
              <div>
                <div
                  className={`${styles.selectArea} ${
                    validation.payAgree && !payAgree
                      ? styles.validationError
                      : ''
                  }`}
                  onClick={() => {
                    if (handleCheck()) setPayAgree((prev) => !prev);
                  }}
                  // onClick={() => setPayAgree((prev) => !prev)}
                >
                  <input
                    type="checkbox"
                    defaultChecked={payAgree}
                    className={payAgree ? styles.checked : ''}
                  />
                  <span>{t('order.39')}</span>
                </div>
                <span
                  onClick={() => {
                    if (isDesktop) setPayAgreeOpen((prev) => !prev);
                    else {
                      setAgreementModalOpen(true);
                      setAgreementModalType(0);
                    }
                  }}
                >
                  {t('order.38')}
                </span>
              </div>
              {payAgreeOpen && <p>{t('order.40')}</p>}
            </li>
            <li>
              <div>
                <div
                  className={`${styles.selectArea} ${
                    validation.privacyAgree && !privacyAgree
                      ? styles.validationError
                      : ''
                  }`}
                  onClick={() => {
                    if (handleCheck()) setPrivacyAgree((prev) => !prev);
                  }}
                  // onClick={() => setPrivacyAgree((prev) => !prev)}
                >
                  <input
                    type="checkbox"
                    defaultChecked={privacyAgree}
                    className={privacyAgree ? styles.checked : ''}
                  />
                  <span>{t('order.41')}</span>
                </div>
                <span
                  onClick={() => {
                    if (isDesktop) {
                      setPrivacyAgreeOpen((prev) => !prev);
                    } else {
                      setAgreementModalOpen(true);
                      setAgreementModalType(1);
                    }
                  }}
                >
                  {t('order.38')}
                </span>
              </div>
              {privacyAgreeOpen && <p>{t('order.42')}</p>}
            </li>
            <li>
              <div>
                <div
                  className={`${styles.selectArea} ${
                    validation.diagnosisAgree && !diagnosisAgree
                      ? styles.validationError
                      : ''
                  }`}
                  onClick={() => {
                    if (handleCheck()) setDiagnosisAgree((prev) => !prev);
                  }}
                  // onClick={() => setDiagnosisAgree((prev) => !prev)}
                >
                  <input
                    type="checkbox"
                    defaultChecked={diagnosisAgree}
                    className={diagnosisAgree ? styles.checked : ''}
                  />
                  <span>{t('order.43')}</span>
                </div>
                <span
                  onClick={() => {
                    if (isDesktop) setDiagnosisAgreeOpen((prev) => !prev);
                    else {
                      setAgreementModalOpen(true);
                      setAgreementModalType(2);
                    }
                  }}
                >
                  {t('order.38')}
                </span>
              </div>
              {diagnosisAgreeOpen && <p>{t('order.44')}</p>}
            </li>
          </ul>

          {payMethod !== 2 && (
            <div className={styles.buyBtnArea}>
              <div
                className={`${styles.buyBtnWrap} ${
                  isFixed ? styles.fixedBtn : ''
                }`}
              >
                <div
                  className={`${styles.buyBtn} ${
                    !paypalBtn ? '' : styles.noBuyBtn
                  }`}
                  // className={styles.buyBtn}
                  onClick={handleSubmit}
                >
                  {t('order.37')}
                </div>
              </div>
            </div>
          )}
          {payMethod === 2 && (
            <div
              style={{
                width: '100%',
                maxWidth: '400px',
                margin: '10px 0',
              }}
            >
              <PayPalScriptProvider
                options={{
                  clientId:
                    'ARpX1t78x10uJxjF339vUIhTzcK7C9tifxVSZoniOfysbBTSk6DELJtLCzihJNOZl6jABhM7ckC06DdZ',
                  // clientId:
                  // 'AQXjlPjxJijywkBp8lnOC_CMxh2C7ESe7-FMVFrkZWzojnRoKoBeTPPExsqkSPvG5T1p8UFNk_jvVT_t',
                  // clientId: 'test',
                  currency: 'USD',
                  intent: 'capture',
                  locale: 'en_US',
                }}
              >
                <PayPalButtons
                  style={{ layout: 'horizontal', height: 55 }}
                  fundingSource="paypal"
                  forceReRender={[
                    orderData,
                    ordererName,
                    ordererEmail,
                    ordererTel,
                    deliveryName,
                    deliveryTel,
                    deliverySnsId,
                    snsIdMethod,
                    zipCode,
                    deliveryCountry,
                    deliveryState,
                    deliveryAddress1,
                    deliveryAddress2,
                    deliveryMemo,
                    deliveryPrice,
                    deliveryPriceSum,
                    payAgree,
                    privacyAgree,
                    diagnosisAgree,
                    usePoint,
                    useCoupon,
                    promotion,
                    promotionPrice,
                    promotionPercent,
                    sellerCoupon,
                    sellerCouponPrice,
                    sellerCouponPercent,
                    totalDiscountPrice,
                    patientName,
                    patientTel,
                    patientAge,
                    patientHeight,
                    patientWeight,
                    pregnancy,
                    reason,
                    disease,
                    diseaseDetail,
                    medicine,
                    medicineDetail,
                    dailyCoffee,
                    caffeineSensitivity,
                    dietPillsExperience,
                    dietPillsLevel,
                    sideEffects,
                    needPrescription,
                  ]}
                  disabled={paypalBtn}
                  createOrder={handleCreateOrder}
                  onApprove={handleOnApprove}
                  onCancel={handleCancel}
                  onError={handleError}
                />
              </PayPalScriptProvider>
            </div>
          )}
          <div ref={buyBtnRef}></div>
        </div>
      </div>
      {/* {openPostcode && (
        <div className={styles.addressModalWrap}>
          <div className={styles.addressModal}>
            <div className={styles.modalHeader}>
              <img
                src={closeBtn}
                alt="closeBtn"
                onClick={() => setOpenPostcode(false)}
              />
            </div>
            <DaumPostcode
              onComplete={handle.selectAddress} // 값을 선택할 경우 실행되는 이벤트
              autoClose={false} // 값을 선택할 경우 사용되는 DOM을 제거하여 자동 닫힘 설정
            />
          </div>
        </div>
      )} */}
      {agreementModalOpen && (
        <div
          className={`${styles.agreementModalContainer} ${
            isMobile ? styles.isMobile : ''
          }`}
        >
          <div className={styles.modal}>
            <h3>
              {agreementModalType == 0
                ? t('order.39')
                : agreementModalType == 1
                ? t('order.41')
                : agreementModalType == 2
                ? t('order.43')
                : ''}
            </h3>
            <div className={styles.content}>
              {agreementModalType == 0
                ? t('order.40')
                : agreementModalType == 1
                ? t('order.42')
                : agreementModalType == 2
                ? t('order.44')
                : ''}
            </div>
            <div
              className={styles.submit}
              onClick={() => setAgreementModalOpen(false)}
            >
              {t('order.45')}
            </div>
          </div>
        </div>
      )}
      {couponModalOpen && (
        <CouponModal
          setOpen={setCouponModalOpen}
          couponList={couponList}
          useCoupon={useCoupon}
          setUseCoupon={setUseCoupon}
        />
      )}
    </div>
  );
}
export default Order;
